import { lazy } from 'react';

export const LazyAcceptTermsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--accept-terms-page" */ './accept-terms-page'
    ),
);
